/**
 * Apaleo OAuth Configuration
 * Uses Authorization Code Grant Flow for web applications
 */

export interface ApaleoConfig {
  clientId: string;
  authorizationEndpoint: string;
  tokenEndpoint: string;
  apiBaseUrl: string;
  redirectUri: string;
  scopes: string[];
}

// OAuth Scopes required for the application
const REQUIRED_SCOPES = [
  'offline_access',
  'availability.read',
  'distribution:reservations.manage',
  'distribution:subscriptions.manage',
  'folios.manage',
  'folios.read',
  'offers.read',
  'rates.read',
  'reservations.manage',
  'reservations.read',
  'setup.read',
];

// Single configuration - reads from environment variables
export const apaleoConfig: ApaleoConfig = {
  clientId: process.env.REACT_APP_APALEO_CLIENT_ID ?? '',
  authorizationEndpoint: 'https://identity.apaleo.com/connect/authorize',
  tokenEndpoint: 'https://identity.apaleo.com/connect/token',
  apiBaseUrl: 'https://app.apaleo.com/api',
  redirectUri: process.env.REACT_APP_APALEO_REDIRECT_URI ?? '',
  scopes: REQUIRED_SCOPES,
};

// Helper function to generate authorization URL
export const getAuthorizationUrl = (state?: string): string => {
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: apaleoConfig.clientId,
    redirect_uri: apaleoConfig.redirectUri,
    scope: apaleoConfig.scopes.join(' '),
    state: state || generateRandomState(),
  });

  return `${apaleoConfig.authorizationEndpoint}?${params.toString()}`;
};

// Helper function to generate random state for CSRF protection
export const generateRandomState = (): string => {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, (byte) => byte.toString(16).padStart(2, '0')).join(
    ''
  );
};

// Validate configuration
export const validateConfig = (): boolean => {
  if (!apaleoConfig.clientId) {
    console.error('Apaleo Client ID is missing');
    return false;
  }
  if (!apaleoConfig.redirectUri) {
    console.error('Apaleo Redirect URI is missing');
    return false;
  }
  return true;
};

export default apaleoConfig;
